import { ApiResult } from '@src/api/apiClient/apiResult';
import { axiosClient } from '@src/api/apiClient/axiosClient';

export const channelInviteRequestApiClient = {
  sendInviteRequest: async (channelCode: string): Promise<ApiResult<void, never>> => {
    return await axiosClient.post(`/community/channels/${channelCode}/invite-request`, {});
  },
};
